import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

// This class is to support non-es2015 browsers; IE and Edge (early versions).
// When we no longer support these browsers this can be removed and navigation
// should use Router directly.
@Injectable()
export class ES5ZoneAwareRouter {

    constructor(
        private readonly zone: NgZone,
        private readonly router: Router) {}

    navigate(commands: any[]): Promise<boolean> {
      return this.zone.run(() => this.router.navigate(commands));
    }

    navigateByUrl(url: string): Promise<boolean> {
      return this.zone.run(() => this.router.navigateByUrl(url));
    }
}
